"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  MAX_Z_INDEX: function MAX_Z_INDEX() {
    return _MAX_Z_INDEX;
  },
  ariaAttr: function ariaAttr() {
    return _ariaAttr;
  },
  contains: function contains() {
    return _contains;
  },
  createScope: function createScope() {
    return _createScope;
  },
  dataAttr: function dataAttr() {
    return _dataAttr;
  },
  getActiveElement: function getActiveElement() {
    return _getActiveElement;
  },
  getByText: function getByText() {
    return _getByText;
  },
  getByTypeahead: function getByTypeahead() {
    return _getByTypeahead;
  },
  getComputedStyle: function getComputedStyle() {
    return _getComputedStyle;
  },
  getDocument: function getDocument() {
    return getDocument2;
  },
  getEventTarget: function getEventTarget() {
    return _getEventTarget;
  },
  getParent: function getParent() {
    return _getParent;
  },
  getPlatform: function getPlatform() {
    return _getPlatform;
  },
  getScrollParent: function getScrollParent() {
    return _getScrollParent;
  },
  getScrollParents: function getScrollParents() {
    return _getScrollParents;
  },
  getWindow: function getWindow() {
    return _getWindow;
  },
  indexOfId: function indexOfId() {
    return _indexOfId;
  },
  isApple: function isApple() {
    return _isApple;
  },
  isDom: function isDom() {
    return _isDom;
  },
  isEditableElement: function isEditableElement() {
    return _isEditableElement;
  },
  isFirefox: function isFirefox() {
    return _isFirefox;
  },
  isHTMLElement: function isHTMLElement() {
    return _isHTMLElement;
  },
  isIPhone: function isIPhone() {
    return _isIPhone;
  },
  isIos: function isIos() {
    return _isIos;
  },
  isMac: function isMac() {
    return _isMac;
  },
  isSafari: function isSafari() {
    return _isSafari;
  },
  isSelfEvent: function isSelfEvent() {
    return _isSelfEvent;
  },
  isTouchDevice: function isTouchDevice() {
    return _isTouchDevice;
  },
  itemById: function itemById() {
    return _itemById;
  },
  nextById: function nextById() {
    return _nextById;
  },
  nextTick: function nextTick() {
    return _nextTick;
  },
  prevById: function prevById() {
    return _prevById;
  },
  query: function query() {
    return _query;
  },
  queryAll: function queryAll() {
    return _queryAll;
  },
  raf: function raf() {
    return _raf;
  }
});
module.exports = __toCommonJS(src_exports);

// src/attrs.ts
var _dataAttr = function _dataAttr(guard) {
  return guard ? "" : void 0;
};
var _ariaAttr = function _ariaAttr(guard) {
  return guard ? "true" : void 0;
};

// src/is-html-element.ts
function _isHTMLElement(value) {
  return _typeof(value) === "object" && (value === null || value === void 0 ? void 0 : value.nodeType) === Node.ELEMENT_NODE && typeof (value === null || value === void 0 ? void 0 : value.nodeName) === "string";
}

// src/contains.ts
function _contains(parent, child) {
  if (!parent || !child) return false;
  if (!_isHTMLElement(parent) || !_isHTMLElement(child)) return false;
  return parent === child || parent.contains(child);
}
var _isSelfEvent = function _isSelfEvent(event) {
  return _contains(event.currentTarget, event.target);
};

// src/create-scope.ts
var getDocument = function getDocument(node) {
  var _node$ownerDocument;
  if (node.nodeType === Node.DOCUMENT_NODE) return node;
  return (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : document;
};
function _createScope(methods) {
  var screen = {
    getRootNode: function getRootNode(ctx) {
      var _ctx$getRootNode, _ctx$getRootNode2;
      return (_ctx$getRootNode = (_ctx$getRootNode2 = ctx.getRootNode) === null || _ctx$getRootNode2 === void 0 ? void 0 : _ctx$getRootNode2.call(ctx)) !== null && _ctx$getRootNode !== void 0 ? _ctx$getRootNode : document;
    },
    getDoc: function getDoc(ctx) {
      return getDocument(screen.getRootNode(ctx));
    },
    getWin: function getWin(ctx) {
      var _screen$getDoc$defaul;
      return (_screen$getDoc$defaul = screen.getDoc(ctx).defaultView) !== null && _screen$getDoc$defaul !== void 0 ? _screen$getDoc$defaul : window;
    },
    getActiveElement: function getActiveElement(ctx) {
      return screen.getDoc(ctx).activeElement;
    },
    getById: function getById(ctx, id) {
      return screen.getRootNode(ctx).getElementById(id);
    }
  };
  return _objectSpread(_objectSpread({}, screen), methods);
}

// src/env.ts
var isDocument = function isDocument(el) {
  return el.nodeType === Node.DOCUMENT_NODE;
};
function getDocument2(el) {
  var _el$ownerDocument;
  if (isDocument(el)) return el;
  return (_el$ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el$ownerDocument !== void 0 ? _el$ownerDocument : document;
}
function _getWindow(el) {
  var _el$ownerDocument$def;
  return (_el$ownerDocument$def = el === null || el === void 0 ? void 0 : el.ownerDocument.defaultView) !== null && _el$ownerDocument$def !== void 0 ? _el$ownerDocument$def : window;
}

// src/get-active-element.ts
function _getActiveElement(el) {
  var activeElement = el.ownerDocument.activeElement;
  while ((_activeElement = activeElement) !== null && _activeElement !== void 0 && _activeElement.shadowRoot) {
    var _activeElement;
    var el2 = activeElement.shadowRoot.activeElement;
    if (el2 === activeElement) break;else activeElement = el2;
  }
  return activeElement;
}

// src/get-by-id.ts
function _itemById(v, id) {
  return v.find(function (node) {
    return node.id === id;
  });
}
function _indexOfId(v, id) {
  var item = _itemById(v, id);
  return item ? v.indexOf(item) : -1;
}
function _nextById(v, id) {
  var loop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var idx = _indexOfId(v, id);
  idx = loop ? (idx + 1) % v.length : Math.min(idx + 1, v.length - 1);
  return v[idx];
}
function _prevById(v, id) {
  var loop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var idx = _indexOfId(v, id);
  if (idx === -1) return loop ? v[v.length - 1] : null;
  idx = loop ? (idx - 1 + v.length) % v.length : Math.max(0, idx - 1);
  return v[idx];
}

// src/get-by-text.ts
var getValueText = function getValueText(item) {
  var _ref, _item$dataset$valuete;
  return (_ref = (_item$dataset$valuete = item.dataset.valuetext) !== null && _item$dataset$valuete !== void 0 ? _item$dataset$valuete : item.textContent) !== null && _ref !== void 0 ? _ref : "";
};
var match = function match(valueText, query2) {
  return valueText.toLowerCase().startsWith(query2.toLowerCase());
};
var wrap = function wrap(v, idx) {
  return v.map(function (_, index) {
    return v[(Math.max(idx, 0) + index) % v.length];
  });
};
function _getByText(v, text, currentId) {
  var index = currentId ? _indexOfId(v, currentId) : -1;
  var items = currentId ? wrap(v, index) : v;
  var isSingleKey = text.length === 1;
  if (isSingleKey) {
    items = items.filter(function (item) {
      return item.id !== currentId;
    });
  }
  return items.find(function (item) {
    return match(getValueText(item), text);
  });
}

// src/get-by-typeahead.ts
function getByTypeaheadImpl(_items, options) {
  var state = options.state,
    activeId = options.activeId,
    key = options.key,
    _options$timeout = options.timeout,
    timeout = _options$timeout === void 0 ? 350 : _options$timeout;
  var search = state.keysSoFar + key;
  var isRepeated = search.length > 1 && Array.from(search).every(function (_char) {
    return _char === search[0];
  });
  var query2 = isRepeated ? search[0] : search;
  var items = _items.slice();
  var next = _getByText(items, query2, activeId);
  function cleanup() {
    clearTimeout(state.timer);
    state.timer = -1;
  }
  function update(value) {
    state.keysSoFar = value;
    cleanup();
    if (value !== "") {
      state.timer = +setTimeout(function () {
        update("");
        cleanup();
      }, timeout);
    }
  }
  update(search);
  return next;
}
var _getByTypeahead = /* @__PURE__ */Object.assign(getByTypeaheadImpl, {
  defaultOptions: {
    keysSoFar: "",
    timer: -1
  },
  isValidEvent: isValidTypeaheadEvent
});
function isValidTypeaheadEvent(event) {
  return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}

// src/get-computed-style.ts
var styleCache = /* @__PURE__ */new WeakMap();
function _getComputedStyle(el) {
  if (!styleCache.has(el)) {
    var win = el.ownerDocument.defaultView || window;
    styleCache.set(el, win.getComputedStyle(el));
  }
  return styleCache.get(el);
}

// src/get-event-target.ts
function _getEventTarget(event) {
  var _event$composedPath$, _event$composedPath;
  return (_event$composedPath$ = (_event$composedPath = event.composedPath) === null || _event$composedPath === void 0 ? void 0 : _event$composedPath.call(event)[0]) !== null && _event$composedPath$ !== void 0 ? _event$composedPath$ : event.target;
}

// src/get-scroll-parent.ts
function isScrollParent(el) {
  var win = el.ownerDocument.defaultView || window;
  var _win$getComputedStyle = win.getComputedStyle(el),
    overflow = _win$getComputedStyle.overflow,
    overflowX = _win$getComputedStyle.overflowX,
    overflowY = _win$getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function _getParent(el) {
  if (el.localName === "html") return el;
  return el.assignedSlot || el.parentElement || el.ownerDocument.documentElement;
}
function _getScrollParent(el) {
  if (["html", "body", "#document"].includes(el.localName)) {
    return el.ownerDocument.body;
  }
  if (_isHTMLElement(el) && isScrollParent(el)) {
    return el;
  }
  return _getScrollParent(_getParent(el));
}
function _getScrollParents(el) {
  var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var parent = _getScrollParent(el);
  var isBody = parent === el.ownerDocument.body;
  var win = parent.ownerDocument.defaultView || window;
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(parent) ? parent : []) : parent;
  var parents = list.concat(target);
  return isBody ? parents : parents.concat(_getScrollParents(_getParent(target)));
}

// src/is-editable-element.ts
function _isEditableElement(el) {
  if (el == null || !_isHTMLElement(el)) {
    return false;
  }
  try {
    var win = el.ownerDocument.defaultView || window;
    return el instanceof win.HTMLInputElement && el.selectionStart != null || /(textarea|select)/.test(el.localName) || el.isContentEditable;
  } catch (_unused) {
    return false;
  }
}

// src/platform.ts
var _isDom = function _isDom() {
  return typeof document !== "undefined";
};
function _getPlatform() {
  var _agent$platform;
  var agent = navigator.userAgentData;
  return (_agent$platform = agent === null || agent === void 0 ? void 0 : agent.platform) !== null && _agent$platform !== void 0 ? _agent$platform : navigator.platform;
}
var pt = function pt(v) {
  return _isDom() && v.test(_getPlatform());
};
var ua = function ua(v) {
  return _isDom() && v.test(navigator.userAgent);
};
var vn = function vn(v) {
  return _isDom() && v.test(navigator.vendor);
};
var _isTouchDevice = function _isTouchDevice() {
  return _isDom() && !!navigator.maxTouchPoints;
};
var _isMac = function _isMac() {
  return pt(/^Mac/) && !_isTouchDevice();
};
var _isIPhone = function _isIPhone() {
  return pt(/^iPhone/);
};
var _isSafari = function _isSafari() {
  return _isApple() && vn(/apple/i);
};
var _isFirefox = function _isFirefox() {
  return ua(/firefox\//i);
};
var _isApple = function _isApple() {
  return pt(/mac|iphone|ipad|ipod/i);
};
var _isIos = function _isIos() {
  return _isApple() && !_isMac();
};

// src/query.ts
function _queryAll(root, selector) {
  var _root$querySelectorAl;
  return Array.from((_root$querySelectorAl = root === null || root === void 0 ? void 0 : root.querySelectorAll(selector)) !== null && _root$querySelectorAl !== void 0 ? _root$querySelectorAl : []);
}
function _query(root, selector) {
  return root === null || root === void 0 ? void 0 : root.querySelector(selector);
}

// src/raf.ts
function _nextTick(fn) {
  var set = /* @__PURE__ */new Set();
  function raf2(fn2) {
    var id = globalThis.requestAnimationFrame(fn2);
    set.add(function () {
      return globalThis.cancelAnimationFrame(id);
    });
  }
  raf2(function () {
    return raf2(fn);
  });
  return function cleanup() {
    set.forEach(function (fn2) {
      return fn2();
    });
  };
}
function _raf(fn) {
  var id = globalThis.requestAnimationFrame(fn);
  return function () {
    globalThis.cancelAnimationFrame(id);
  };
}

// src/index.ts
var _MAX_Z_INDEX = 2147483647;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  MAX_Z_INDEX: _MAX_Z_INDEX,
  ariaAttr: _ariaAttr,
  contains: _contains,
  createScope: _createScope,
  dataAttr: _dataAttr,
  getActiveElement: _getActiveElement,
  getByText: _getByText,
  getByTypeahead: _getByTypeahead,
  getComputedStyle: _getComputedStyle,
  getDocument: getDocument,
  getEventTarget: _getEventTarget,
  getParent: _getParent,
  getPlatform: _getPlatform,
  getScrollParent: _getScrollParent,
  getScrollParents: _getScrollParents,
  getWindow: _getWindow,
  indexOfId: _indexOfId,
  isApple: _isApple,
  isDom: _isDom,
  isEditableElement: _isEditableElement,
  isFirefox: _isFirefox,
  isHTMLElement: _isHTMLElement,
  isIPhone: _isIPhone,
  isIos: _isIos,
  isMac: _isMac,
  isSafari: _isSafari,
  isSelfEvent: _isSelfEvent,
  isTouchDevice: _isTouchDevice,
  itemById: _itemById,
  nextById: _nextById,
  nextTick: _nextTick,
  prevById: _prevById,
  query: _query,
  queryAll: _queryAll,
  raf: _raf
});